/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  viewBox: "0 0 32 29",
  fill: "currentColor",
  "aria-hidden": "true",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: "2"
}, React.createElement("path", {
  d: "M25.537 17.312c2.092.825 3.483 2.915 3.483 5.235v5.717c0 .545-.55.9-1.021.658-1.576-.81-4.684-2.612-7.199-5.336-.15-.338-2.294-5.395 2.821-6.993l1.916.719zM30.109.119c.171-.077.356-.118.543-.118.74 0 1.348.63 1.348 1.395v7.515c0 3.561-2.234 4.41-4.407 4.95-3.174.788-11.546 2.75-6.806 9.71-2.121-2.3-3.817-5.256-3.817-8.827 0-7.783 9.101-12.788 13.14-14.625zM8.38 16.594c5.115 1.598 2.97 6.654 2.82 6.992-2.515 2.724-5.623 4.526-7.2 5.336a.68.68 0 01-.314.075c-.387 0-.706-.33-.706-.732v-5.719c0-2.32 1.391-4.41 3.483-5.234l1.916-.719v.001zM1.89.118C5.929 1.956 15.03 6.96 15.03 14.744c0 3.571-1.697 6.527-3.818 8.828 4.74-6.962-3.632-8.923-6.806-9.71C2.234 13.321 0 12.472 0 8.91V1.396C0 .388.999-.286 1.89.12V.118z",
  fill: "#fff"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Logo";
Svg.element = element;
export default Svg;
